import React from "react";

export default function Submission() {
  return (
    <div style={{ marginTop: "7rem" }}>
      <div className="container">
        <div className="about">
          <div className="card border-primary mb-3" style={{ width: "auto" }}>
            <div className="card-body">
              <h5 className="card-title text-primary">
                MANUSCRIPT SUBMISSION FORMAT
              </h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div style={{ margin: "1rem" }}>
                <ul className="card-text" style={{ listStyle: "disc" }}>
                  <li>
                    The conference papers should be submitted through Mail ID :{" "}
                    <span style={{ color: "blue" }}>
                      etcan21@kongunadu.ac.in
                    </span>
                  </li>
                  <li id="doc">
                    <a id="doc_ref" href="./docs/Grenze template.docx" download>
                      Click here
                    </a>{" "}
                    to download the template for preparing your manuscripts.
                  </li>
                  <li>
                    Once your paper is accepted for the conference, you have to
                    submit Final version of your paper.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about">
        <div className="card border-0 mb-10" style={{ width: "auto" }}>
          <div className="card-body">
            <h5 className="card-title text-primary">IMPORTANT DATES</h5>
            <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
            <div id="table">
              <table className="table table-hover">
                <tbody className="table-bordered border-primary">
                  <tr>
                    <td>Last date for Manuscript submission</td>
                    <td>
                      <p
                        style={{ textDecoration: "line-through", margin: "0" }}
                      >
                        September 09, 2021
                      </p>
                      <p style={{ margin: "0", fontWeight: "700" }}>
                        Extended upto September 20, 2021
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>Notification of Acceptance</td>
                    <td>October 9, 2021</td>
                  </tr>
                  <tr>
                    <td>Last date for Camera Ready Paper</td>
                    <td>October 15, 2021</td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
